const tlMessages= {
  /* 01.General */
   "main.name": "Pangalan",
  "main.sentiment": "Damdamin",
  "main.urgency": "Pagiging madalian",
  "main.language": "Wika",
  "main.agent": "Ahente",
  "main.property_name": "Pangalan ng ari-arian",
  "main.booking_number": "Numero ng booking",
  "main.check_out": "Pag-check out",
  "main.check_in": "Pag-check in",
  "main.adults": "Mga matatanda",
  "main.corporate_code": "Corporate code",
  "main.group_code": "Group code",
  "main.promo_code": "Promo code",
  "main.ai_response": "Sagot ng AI",
  "main.template_response": "Sagot ng template",
  "main.converttoticket": "I-convert sa ticket",
  "main.switch_property": "Palitan ang ari-arian",
  "main.Group_id": "ID ng grupo",
  "main.integration_id": "ID ng integration",
  "main.submit": "Isumite",
  "main.cancel": "Kanselahin",
    "main.select_template": "Pumili ng Template",
  "main.rooms": "Mga Kwarto",
  "main.rates": "Mga Rate",

  //footer
   "footer.knowledge": "Kaalaman",
  "footer.home": "Home",
  "footer.help": "Tulong",

  //ticket
  "ticket.thank_you": "Salamat sa pagsusumite ng form",
  "ticket.ticket": "Ticket",
  "ticket.details": "Pakipunan ang form na naglalarawan ng mga detalye ng ticket.",
  "ticket.select_category": "Pumili ng Kategorya",
  "ticket.category": "Kategorya",
  "ticket.title": "Pamagat",
  "ticket.notes": "Mga Tala",
  "ticket.status": "Katayuan",
  "ticket.assigned_to": "Itinalaga Kay",
  "ticket.submit_form": "Isumite ang Form",

  
  "main.total": "Kabuuan",
  "main.pastetooutlook": "I-paste sa Outlook",
  "main.children": "Mga Bata",
  "main.promocode": "Promo/Korporasyon/Group Code",
  "main.exact_match_only": "Eksaktong Tugma Lamang",
  "main.search": "Maghanap",
  "main.no_rate_match": "Walang rate na tumutugma sa iyong napili. Baguhin ang iyong paghahanap at subukan muli.",
  "main.translate_to": "Isalin sa",
  "main.regenerate": "Bumuo Muli",
  "main.copy_text": "Kopyahin ang Teksto",
  "main.additional_instructions": "Karagdagang Tagubilin",

  "faq.helpcenter": "Help Center",
  "faq.reply.email.sabre.question": "Paano ako sasagot sa email gamit ang Aven Hospitality Concierge Email Automation?",
  "faq.reply.email.sabre.answer": "Buksan ang email at ilunsad ang Aven Hospitality add-in. Maaari kang pumili sa tatlong opsyon: gumamit ng paunang template, gumawa ng AI response, o gawing ticket ang email. Piliin ang pinakamainam na opsyon, suriin ang sagot, gumawa ng pagbabago kung kinakailangan, at ipadala nang direkta mula sa Outlook.",

  "faq.rates.availability.question": "Paano ako magdaragdag ng rates, availability, at detalye ng kwarto sa aking sagot?",
  "faq.rates.availability.answer": "Gamitin ang + Rates upang ilagay ang detalye ng bisita tulad ng petsa at bilang ng bisita. Ilalagay ng Concierge ang tamang availability at presyo sa iyong sagot. Maaari mo ring gamitin ang + Rooms upang magdagdag ng paglalarawan at larawan ng kwarto.",

  "faq.different.language.question": "Ano ang dapat kong gawin kung ang email ay nasa ibang wika?",
  "faq.different.language.answer": "Pinapayagan ka ng Aven Hospitality Concierge na isalin ang mga papasok na email sa iyong gustong wika.",

  "faq.pin.addin.question": "Paano ko masisiguro na laging available ang add-in sa Outlook?",
  "faq.pin.addin.answer": "I-pin ang Aven Hospitality Concierge add-in sa Outlook upang manatili itong nakikita.",

  "faq.knowledge.hub.question": "Ano ang Knowledge Hub search option?",
  "faq.knowledge.hub.answer": "Pinapayagan ka ng Knowledge Hub search na mabilis na makahanap ng impormasyon tungkol sa property sa Outlook.",

  "faq.reply.email.myma.question": "Paano ako sasagot sa email gamit ang Myma?",
  "faq.reply.email.myma.answer": "Buksan ang email at ilunsad ang Myma add-in. Maaari kang gumamit ng template, gumawa ng AI response, o gawing ticket ang email.",

  "faq.room.details.question": "Paano ako magdaragdag ng detalye ng kwarto sa aking sagot?",
  "faq.room.details.answer": "Gamitin ang + Rooms upang magdagdag ng paglalarawan at larawan ng mga kwarto.",

  "faq.myma.different.language.question": "Ano ang dapat kong gawin kung ang email ay nasa ibang wika?",
  "faq.myma.different.language.answer": "Pinapayagan ng Myma ang pagsasalin ng mga papasok na email sa iyong gustong wika.",

  "faq.myma.pin.addin.question": "Paano ko masisiguro na laging available ang add-in sa Outlook?",
  "faq.myma.pin.addin.answer": "I-pin ang Myma add-in sa Outlook upang awtomatiko itong bumukas sa bawat email.",

};
export default tlMessages;